import React, { useState } from 'react';
import { signup } from '../assets';
import { API_BASE_URL } from '../config';
import './Auth.css';

const Auth = ({ onVerify }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        
        try {
            const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    mail: username,
                    password: password
                })
            });

            const data = await response.json();

            if (data.success) {
                // Store user data in session storage
                sessionStorage.setItem('user', JSON.stringify({
                    username: data.user.mail,
                    role: data.user.role,
                    isAuthenticated: true
                }));
                
                onVerify(true);  // If verified, set verify to true
            } else {
                alert(data.error || 'Invalid credentials. Please try again.');
                onVerify(false); // Keep verify false on failed login
            }
        } catch (error) {
            console.error('Login error:', error);
            alert('An error occurred. Please try again.');
            onVerify(false);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="auth__form-container">
            <div className="auth__form-container_fields">
                <div className="auth__form-container_fields-content">
                    <p>Sign In</p>
                    <form onSubmit={handleSubmit}>
                        <div className="auth__form-container_fields-content_input">
                            <label htmlFor="username">Username</label>
                            <input
                                name="username"
                                type="text"
                                placeholder="Username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                required
                            />
                        </div>

                        <div className="auth__form-container_fields-content_input">
                            <label htmlFor="password">Password</label>
                            <input
                                name="password"
                                type="password"
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                        </div>

                        <div className="auth__form-container_fields-content_button">
                            <button type="submit" disabled={loading}>
                                {loading ? 'Signing In...' : 'Sign In'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <div className="auth__form-container_image">
                <img src={signup} alt="sign in" />
            </div>
        </div>
    );
}

export default Auth;

